export default {
  firebase: {
    apiKey: 'AIzaSyAqiGb2uoQOSf2UmeCf8gZnI5pS785tOc4',
    authDomain: 'mis.nafoods.com',
    databaseURL: 'https://mis-prod.firebaseio.com/',
    projectId: 'mis-prod',
    storageBucket: 'mis-prod.appspot.com',
    messagingSenderId: '566729970104'
  }
}